import { render, staticRenderFns } from "./info-modal.vue?vue&type=template&id=2077715e&scoped=true"
import script from "./info-modal.vue?vue&type=script&lang=js"
export * from "./info-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2077715e",
  null
  
)

export default component.exports